import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { getComponentNameLong } from "../model/util/Components";
import { getUnit, formatUnitValue } from "../einheiten/Units";

import "./Waermerueckgewinnung.css";

const genRow1 = (i18n_key, intl, value, unit_name) => {
	let unit = getUnit(unit_name);
	return {
		id: i18n_key,	/* für rowKey */
		label: intl.formatMessage({ id: i18n_key }),
		values: <span>{formatUnitValue(value, unit, intl) + " " +
			unit.genUnitText(intl)}</span>
	};
};

const genRow2 = (i18n_key, intl, value, unit_name) => {
	let row = genRow1(i18n_key, intl, value, unit_name);
	/* TODO: 365 stimmt überhaupt nicht, weil der Berichtszeitraum mit in Betracht gezogen werden muss ... siehe Flex-Lösung */
	row.values = (<div>
		{row.values}<br />
		<span>{formatUnitValue(value * 365, getUnit(unit_name), intl, 0) +
			intl.formatMessage({ id: "(year)" })}</span>
	</div>);
	return row;
};

const genRows = (wrg, units, unit_heating_material, intl) => {
	return [
		genRow1("Average heat power", intl, wrg.waerme_avg, units.power),
		genRow2("Usable heat", intl, wrg.waerme_nutzbar, units.energy),
		genRow1("heated water", intl, wrg.erwaermtes_wasser, units.volume_over_hours),
		genRow2("Saved heating material", intl, wrg.eingespartes_heizmaterial, unit_heating_material),
		genRow2("Saved heating cost", intl, wrg.eingesparte_heizkosten, units.currency),
		genRow2("Saved CO²", intl, wrg.eingespartes_co2, "kg")
	];
};

const genTable = (wrg, i, compressors, units, unit_heating_material, intl) => (
	<Table.Provider key={i} columns={[{
		property: "label"
	}, {
		property: "values",
		header: {
			label: getComponentNameLong(wrg.cindex, compressors, intl)
		}
	}]}>
		<Table.Header />
		<Table.Body rows={genRows(wrg, units, unit_heating_material, intl)} rowKey={({ rowData }) => rowData.id} />
	</Table.Provider>
);

const genTables = (wrg, compressors, units, unit_heating_material, intl) => (
	wrg.map((wrg, i) => genTable(wrg, i, compressors, units, unit_heating_material, intl))
);

const Waermerueckgewinnung = props => (
	<div className="waermerueckgewinnung">
		{ genTables(props.wrg, props.compressors, props.units, props.unit_heating_material, props.intl) }
	</div>
);

Waermerueckgewinnung.propTypes = {
	wrg: PropTypes.arrayOf(PropTypes.object).isRequired,
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
	units: PropTypes.object.isRequired,
	intl: intlShape.isRequired,
	unit_heating_material: PropTypes.string.isRequired
};

export default injectIntl(Waermerueckgewinnung);
